import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, openConvSocket } from "../../../lib/api";
import { provName } from "./llmUtil";

// Unacknowledged LLM alert count + realtime toasts via the user WebSocket channel (super_admin only).
export function useLlmAlerts(enabled) {
  const [count, setCount] = useState(0);
  const seen = useRef(new Set());
  const refresh = useCallback(() => { if (enabled) api.get("/admin/llm/alerts", { params: { unacknowledged: true, limit: 1 } }).then((r) => setCount(r.data.unacknowledged || 0)).catch(() => {}); }, [enabled]);
  useEffect(() => {
    if (!enabled) return undefined;
    refresh();
    let sock = null;
    const t = setTimeout(() => { sock = openConvSocket("user", (ev) => {
      if (ev?.type !== "admin_llm_alert" || !ev.alert) return;
      const a = ev.alert;
      if (a.id && seen.current.has(a.id)) return;
      if (a.id) seen.current.add(a.id);
      refresh();
      (a.severity === "critical" ? toast.error : toast.warning)(`AI · ${provName(a.provider)}`, { description: a.message, duration: 10000 });
    }, refresh); }, 300);
    return () => { clearTimeout(t); sock?.close(); };
  }, [enabled, refresh]);
  return [count, refresh];
}
